import React from 'react';
import { useLayoutContext } from '@context/LayoutContext';
import { ICollection, MegaMenuEntry, TCollectionType } from '@monofront/types';
import TreeCard, {
  Button,
  Image,
  List,
  Title,
} from '@monofront/design-system/components/TreeCard';
import { useTranslations } from 'next-intl';
import { getMegamenuEntryLabel } from '@monofront/business/utils';

interface ICollectionHubTreeCardsProps {
  collection: ICollection;
}

export const CollectionHubTreeCards: React.FC<ICollectionHubTreeCardsProps> = ({
  collection,
}) => {
  const tCatalog = useTranslations('Catalog');
  const { megamenu } = useLayoutContext();

  const collectionHub: MegaMenuEntry[] | null =
    (collection.type === TCollectionType.hub &&
      megamenu.collections.find(
        (megamenuCollection) =>
          megamenuCollection.linkedCollection.handle === collection.handle,
      )?.subCollections) ||
    null;

  if (!collectionHub?.some((item) => item.subCollections.length > 0)) {
    return null;
  }

  return (
    <>
      {collectionHub.map((item) => {
        const entryLabel = getMegamenuEntryLabel(item);

        return (
          <TreeCard
            key={item.linkedCollection.handle}
            listCount={item.subCollections.length}
            label={entryLabel}
            url={`/collections/${item.linkedCollection.handle}`}
            icon={item.linkedCollection.icon}
          >
            {item.linkedCollection.icon && (
              <Image src={item.linkedCollection.icon} />
            )}
            <Title
              label={entryLabel}
              url={`/collections/${item.linkedCollection.handle}`}
              dataTestId={`Tree card title link ${entryLabel}`}
            />
            {item.subCollections.length > 0 && (
              <>
                <List
                  list={item.subCollections.map((subCollection) => ({
                    label: getMegamenuEntryLabel(subCollection),
                    url: `/collections/${subCollection.linkedCollection.handle}`,
                    dataTestId: `Tree card unit of the collection ${getMegamenuEntryLabel(
                      subCollection,
                    )}`,
                    dataTestName: 'Tree card unit',
                  }))}
                  dataTestId={`Tree card list of the collection ${entryLabel}`}
                />
                <Button
                  seeMoreLabel={tCatalog('seeMore')}
                  seeLessLabel={tCatalog('seeLess')}
                  dataTestId={`Tree card see more button of the collection ${entryLabel}`}
                />
              </>
            )}
          </TreeCard>
        );
      })}
    </>
  );
};
